import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// import axios from 'axios';
import { MdOutlineEventNote } from 'react-icons/md';
import './AuthorHome.css';

const AuthorHome = () => {
  // Static dates - commented out API calls
  const staticDates = {
    PaperSubmissionDeadline: "7th December 2025",
    AcceptanceNotification: "14th December 2025",
    RegistrationDeadline: "23th December 2025",
    CameraReadySubmission: "15 May 2026"
  };

  const [date] = useState({ data: [staticDates] });
  // const [error, setError] = useState(null);
  // const [loading, setLoading] = useState(true);

  // Commented out API call
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/get-date`
  //       );
  //       setDate(response.data);
  //     } catch (error) {
  //       console.error('Error fetching date data', error);
  //       setError(error.message);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, []);

  // Commented out loading and error states since using static content
  // if (loading) {
  //   return <div className="loading-state">Loading important dates...</div>;
  // }

  // if (error) {
  //   return <div className="error-state">Error loading dates: {error}</div>;
  // }

  return (
    <div className="author-home-container">
      <div className="author-dates-header">
        <h1 className="author-dates-title">Important Dates</h1>
        <p className="author-dates-subtitle">Key deadlines for the conference</p>
      </div>

      <div className="author-dates-container">
        <div className="author-date-card">
          <MdOutlineEventNote className="author-date-icon" />
          <div className="author-date-content">
            <h3>Paper Submission Deadline</h3>
            <p className="author-deadline-date">{date.data[0].PaperSubmissionDeadline}</p>
          </div>
        </div>

        <div className="author-date-card">
          <MdOutlineEventNote className="author-date-icon" />
          <div className="author-date-content">
            <h3>Acceptance Notification</h3>
            <p className="author-notification-date">{date.data[0].AcceptanceNotification}</p>
          </div>
        </div>

        <div className="author-date-card">
          <MdOutlineEventNote className="author-date-icon" />
          <div className="author-date-content">
            <h3>Registration Deadline</h3>
            <p className="author-registration-date">{date.data[0].RegistrationDeadline}</p>
          </div>
        </div>

        <div className="author-date-card">
          <MdOutlineEventNote className="author-date-icon" />
          <div className="author-date-content">
            <h3>Conference Date</h3>
            <p className="author-symposium-date">{date.data[0].CameraReadySubmission}</p>
          </div>
        </div>
      </div>

      <button 
        className="author-call-for-paper-btn"
        onClick={() => window.open('https://drive.google.com/file/d/1Pj-YwsJo4Ev_YVxL8lvAPNapBtUB7nUA/view?usp=sharing', '_blank')}
      >
        Call For Paper
      </button>
    </div>
  );
};

export default AuthorHome;